import { render, staticRenderFns } from "./BrokerForm.vue?vue&type=template&id=196418e0"
import script from "./BrokerForm.vue?vue&type=script&lang=js"
export * from "./BrokerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports